module.exports = __webpack_public_path__ + "static/media/falsemirrorgrid.37cd7d6a.jpg";